import React from 'react';
import {
  Autocomplete,
  Box,
  Chip,
  FormControl,
  FormHelperText,
  TextField,
  Typography,
} from '@mui/material';
import { FIELD_STYLES } from './fieldStyles';

const AutocompleteField = ({
  id,
  label,
  required = false,
  value,
  onChange,
  inputValue,
  onInputChange,
  options = [],
  placeholder,
  error,
  helperText,
  disabled = false,
  multiple = false,
  renderOption,
  getOptionLabel = (option) => option.name ?? '',
  isOptionEqualToValue = (option, val) => option.id === val.id,
  filterSelectedOptions = false,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      {label && (
        <Typography variant="body2" fontWeight={600}>
          {label}
          {required && (
            <Box component="span" sx={{ color: 'error.main', ml: 0.25 }}>
              *
            </Box>
          )}
        </Typography>
      )}

      <FormControl fullWidth error={!!error} disabled={disabled}>
        <Autocomplete
          id={id}
          multiple={multiple}
          value={value}
          onChange={(_, newValue) => onChange(newValue)}
          inputValue={inputValue}
          onInputChange={(_, newInputValue) => onInputChange?.(newInputValue)}
          options={options}
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          filterSelectedOptions={filterSelectedOptions}
          disabled={disabled}
          renderTags={
            multiple
              ? (values, getTagProps) =>
                  values.map((option, index) => (
                    <Chip
                      label={getOptionLabel(option)}
                      {...getTagProps({ index })}
                      key={option.id}
                    />
                  ))
              : undefined
          }
          renderOption={
            renderOption
              ? (props, option) => (
                  <li {...props} key={option.id}>
                    {renderOption(option)}
                  </li>
                )
              : undefined
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={placeholder}
              error={!!error}
              sx={{
                '& .MuiOutlinedInput-root': {
                  minHeight: FIELD_STYLES.minHeight,
                  fontSize: FIELD_STYLES.fontSize,
                  padding: `${FIELD_STYLES.paddingY} ${FIELD_STYLES.paddingX} !important`,
                },
              }}
            />
          )}
        />

        {(error || helperText) && (
          <FormHelperText sx={{ m: 0 }}>{error || helperText}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
};

export default AutocompleteField;